import { Skeleton } from "@vega-core/components/shadcn/skeleton";

export const CoInvestmentItemSkeleton = () => (
  <div
    className="grid grid-cols-1 2xl:grid-cols-[1fr_1.1fr] gap-4 justify-between py-6 md:p-6 first:border-t-1 first:border-border/primary last:border-b-1 last:border-border/primary"
    data-testid="co-investment-item-skeleton"
  >
    <div className="flex flex-col col-span-1 sm:flex-row gap-4 px-2 md:px-0">
      <Skeleton className="w-16 h-16 min-w-16 rounded-lg" />
      <div className="flex flex-col gap-y-2 flex-1">
        <div className="flex flex-col text-left gap-1">
          <Skeleton className="h-6 w-48 rounded" />
          <Skeleton className="h-4 w-32 rounded" />
        </div>
      </div>
    </div>
    <div className="grid grid-cols-1 sm:grid-cols-2 divide-border/primary sm:items-center sm:gap-4">
      <div className="flex flex-row justify-between sm:flex-col 2xl:text-right gap-1 py-2 px-2 sm:px-4 l:px-l-4 2xl:px-l-8">
        <Skeleton className="h-4 w-20 rounded" />
        <Skeleton className="h-5 w-16 rounded" />
      </div>
      <div className="flex flex-row justify-between sm:flex-col 2xl:text-right gap-1 py-2 px-2 sm:px-4 l:px-l-4 2xl:px-l-8">
        <Skeleton className="h-4 w-20 rounded" />
        <Skeleton className="h-5 w-16 rounded" />
      </div>
    </div>
  </div>
);
